import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface ReasonSectionProps {
  number: string;
  title: string;
  description: string;
  subtext: string;
  benefits: string[];
  quote: string;
  imageUrl: string;
  reverse?: boolean;
  attribution?: string;
}
export const ReasonSection: React.FC<ReasonSectionProps> = ({
  number,
  title,
  description,
  subtext,
  benefits,
  quote,
  imageUrl,
  reverse = false,
  attribution
}) => {
  return <section className="py-12 border-t border-gray-200" data-id="element-28">
      <div className="w-full mb-8" data-id="element-29">
        <img src={imageUrl} alt={`Zenora Smart Ring - ${title}`} className="rounded-lg shadow-lg w-full h-auto" data-id="element-30" />
      </div>
      <div data-id="element-31">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-32">
          {number.replace('️⃣', '')}: {title}
        </h2>
        <p className="text-lg text-gray-700 mb-4" data-id="element-33">{description}</p>
        {subtext && <p className="text-lg text-gray-700 mb-6" data-id="element-34">{subtext}</p>}
        {benefits.length > 0 && <ul className="space-y-3 mb-6" data-id="element-35">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-36">
                <CheckCircleIcon className="h-6 w-6 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-37" />
                <span className="text-gray-700" data-id="element-38">{benefit}</span>
              </li>)}
          </ul>}
        {quote && <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6" data-id="element-39">
            <p className="text-gray-700 italic" data-id="element-40">"{quote}"</p>
            {attribution && <p className="text-gray-600 mt-2" data-id="element-41">{attribution}</p>}
          </div>}
      </div>
    </section>;
};